// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminFee_wrapper___1POM","isPdp":"AdminFee_isPdp___ho89","feeText":"AdminFee_feeText___TY_2"};